const values = [
  {
    icon: "ri-vip-diamond-line",
    title: "平台定位",
    desc: "专注原版韩漫的尊享阅读平台，以高画质资源与无广告体验，为每一位读者提供纯粹、高品质的追漫享受。",
  },
  {
    icon: "ri-compass-3-line",
    title: "发展理念",
    desc: "坚持正版与精品并重，紧跟热门连载节奏，持续扩充分类与内容储备，让尊享阅读成为日常习惯。",
  },
  {
    icon: "ri-file-shield-line",
    title: "内容原则",
    desc: "重视画面呈现与翻译质量，逐话精修、稳定更新，确保每一次阅读都能原汁原味地呈现创作者的心血。",
  },
];

export default function About() {
  return (
    <section id="about" className="relative py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="overflow-hidden rounded-lg border border-background-600/60 bg-background-900/60">
          <div className="grid lg:grid-cols-2">
            <div className="relative min-h-[260px]">
              <img
                src="https://readdy.ai/api/search-image?query=Premium%20manga%20reading%20brand%20concept%20scene%2C%20stack%20of%20stylish%20comic%20books%20on%20a%20wooden%20desk%20with%20warm%20golden%20reading%20lamp%2C%20dark%20elegant%20background%2C%20golden%20particles%20floating%2C%20luxury%20and%20literary%20atmosphere%2C%20cinematic%20composition%2C%20warm%20amber%20tones&width=1200&height=800&seq=about-brand&orientation=landscape"
                alt="韩漫土豪漫画网品牌介绍"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-background-900/60 lg:bg-gradient-to-l"></div>
            </div>
            <div className="p-6 md:p-10">
              <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-400">
                <i className="ri-building-2-line"></i>
                关于我们
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-50 md:text-3xl">
                韩漫土豪漫画网，<span className="text-gradient-gold">只为尊享的你</span>
              </h2>
              <p className="mt-4 text-sm leading-relaxed text-foreground-400">
                韩漫土豪漫画网是一站式韩漫阅读平台。我们深知每一位读者的时间与喜好同样宝贵，因此始终坚持用更好的画质、更快的更新和更纯粹的体验来回馈支持。从都市豪门到热血战斗，从逆袭爽文到甜宠恋爱，海量原版韩漫一网打尽，VIP
                章节付费解锁抢先看，让尊享阅读触手可及。
              </p>

              <div className="mt-6 grid gap-3 sm:grid-cols-3">
                {values.map((v) => (
                  <div
                    key={v.title}
                    className="rounded-md border border-background-600/60 bg-background-950/40 p-3.5"
                  >
                    <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500/15 text-lg text-primary-400">
                      <i className={v.icon}></i>
                    </span>
                    <h3 className="mt-2.5 text-sm font-semibold text-foreground-50">{v.title}</h3>
                    <p className="mt-1 text-xs leading-relaxed text-foreground-500">{v.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}